
import { Routes, Route, Link } from "react-router-dom";














export default function About() {
  return (
   <h2>About Page</h2>
  );
}